export interface FabricForgotPasswordFeatureFlag {
	isEnabled: boolean;
	settings: Record<string, any>;
}

export const FORGOT_PASSWORD_TRANSLATIONS = {
	translations: [
		"forgot-password.info",
		"forgot-password.email.placeholder",
		"forgot-password.email.required",
		"forgot-password.email.emailInvalid",
		"forgot-password.reset-password",
		"forgot-password.success-message",
		"general.ok",
	],
};
